import { Component, OnDestroy, OnInit, Renderer2 } from '@angular/core';
import { Location } from '@angular/common';

@Component({
	selector: 'vitens-taskforce',
	templateUrl: './taskforce.component.html',
	styleUrls: ['./taskforce.component.scss'],
	host: { 'class': 'd-flex align-items-center justify-content-center p-5' }
})
export class TaskforceComponent implements OnInit, OnDestroy {

	constructor(
		private renderer: Renderer2,
		private location: Location
	) {
		this.renderer.addClass(document.body, 'no-header');
	}

	ngOnInit() {

	}

	retry() {

		this.location.back();
	}

	ngOnDestroy() {

		this.renderer.removeClass(document.body, 'no-header');
	}
}